import React from "react";

import { BoxProps, Hide } from "@catchoftheday/cg-components";
import { styled, theme, themeGet } from "@catchoftheday/theme";
import { minusOnePx, useMedia } from "@catchoftheday/utilities";

import { Container } from "../../components/Container";
import { AccountMenu, EssentialsMenu, Shop } from "../../types";

import { MobileMenuContext } from "./MobileNav/MobileMenuContext";
import { DesktopNav } from "./DesktopNav";
import { MobileNav } from "./MobileNav";

export type MegaMenuProps = {
  shops: Shop[];
  essentialsMenu?: EssentialsMenu;
  accountMenu: AccountMenu;
  isLoggedIn?: boolean;
  cartItemsCount?: number;
  wishlistItemsCount?: number;
} & BoxProps;

const DesktopContainer = styled(Container)`
  &::after {
    content: "";
    position: absolute;
    bottom: 0px;
    z-index: 0;
    left: 0px;
    width: 100%;
    height: 2px;
    background-color: ${(props) => themeGet("colors.grey")(props)};
  }

  @media (max-width: ${(props) =>
      minusOnePx(
        themeGet("breakpoints.lg")(props)
      )}) and (min-width: ${themeGet("breakpoints.md")}) {
    padding-left: 0;
    padding-right: 0;
    position: relative;
    overflow: hidden;
  }
`;

export const MegaMenu: React.FC<MegaMenuProps> = ({
  shops,
  essentialsMenu,
  accountMenu,
  isLoggedIn,
  cartItemsCount,
  wishlistItemsCount,
}) => {
  const isMobile = useMedia<boolean>(
    [`(max-width: ${minusOnePx(theme.breakpoints.md, true)})`],
    [true]
  );

  if (isMobile) {
    return (
      <MobileMenuContext.Provider
        value={{
          shops,
          essentialsMenu,
          accountMenu,
          isLoggedIn,
          cartItemsCount,
          wishlistItemsCount,
        }}
      >
        <MobileNav />
      </MobileMenuContext.Provider>
    );
  }

  return (
    <Hide xs sm>
      <DesktopContainer
        position="relative"
        backgroundColor="ui.backgroundColor"
      >
        <DesktopNav shops={shops} />
      </DesktopContainer>
    </Hide>
  );
};
